import { useQuery } from '@tanstack/react-query';

import { captureException } from '../../logger/Logger';
import { useMastraClient } from '../providers/MastraClient';

export const useListTraces = ({
    threadId,
    entityId,
    enabled = true,
}: {
    threadId?: string;
    entityId?: string;
    enabled?: boolean;
}) => {
    const mastraClient = useMastraClient();

    return useQuery({
        queryKey: ['observability-traces', threadId, entityId],
        queryFn: async () => {
            try {
                const response = await mastraClient.listTraces({
                    filters: {
                        ...(threadId != null && { threadId }),
                        ...(entityId != null && { entityId }),
                    },
                    pagination: { page: 0, perPage: 50 },
                });

                return response;
            } catch (err) {
                captureException(err);
                throw err;
            }
        },
        enabled,
        refetchInterval: 5000,
        refetchOnWindowFocus: false,
    });
};
